import addError from '../../../utils/error.jsx';

export function request(id, marketId, eventId, result) {
    return {
        type: 'SELECTIONS_RESULT_REQUEST',
        result,
        marketId,
        eventId,
        id
    };
}

export function error(id, errors) {
    addError(errors);

    return {
        type: 'SELECTIONS_RESULT_ERROR',
        errors,
        id
    };
}

export function finish(id) {
    return {
        type: 'SELECTIONS_RESULT_FINISH',
        id
    };
}

export function bulkResult(marketId, eventId, selections ) {
    return {
        type: 'SELECTIONS_RESULT_BULK_REQUEST',
        marketId,
        eventId,
        selections
    };
}
